import { IGroupByRecord, IgxNumberSummaryOperand, IgxSummaryOperand, IgxSummaryResult } from "@infragistics/igniteui-angular";

export class TotalSummaryOperand extends IgxSummaryOperand
{
    override operate(
        currentColumnValues: ReadonlyArray<string | number | Date | boolean>,
        _gridRows: unknown[] = [],
        _fieldName?: string,
        _groupRecord?: IGroupByRecord): IgxSummaryResult[]
    {
        const numericData = currentColumnValues.filter(x => typeof x === "number");
        return [
            {
                key: "total",
                label: "",
                // summaryResult: allGridData.length === 0 ? 0 : allGridData[0][`total.${fieldName}`],
                summaryResult: IgxNumberSummaryOperand.sum(numericData)
            }
        ];
    }
}

/**
 * This class is just so we can use the `instanceof` operator when determining how to format the result.
 */
export class TotalCurrencySummaryOperand extends TotalSummaryOperand
{
}
